import { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import axios from "axios";
import { KeyRound } from "lucide-react";
import { Button, Checkbox } from "../../components";
import { useAuth } from "../../context/AuthContext";
import { useTenant } from "../../context/TenantContext";
import { REGISTER_INVITE_CONFIRM_URL } from "../../features/UrlHelper";
import "./PozvankaPage.scss";

/**
 * Zakaznik pozvany obsluhou si nastavuje heslo (R11).
 *
 * PRECO SAMOSTATNA OBRAZOVKA A NIE REGISTRACIA:
 *   Ucet uz existuje aj s historiou objednavok a saldom -- nic nove nevznika,
 *   iba sa k nemu doplni prihlasenie. Registracny formular by sa navyse pytal
 *   na udaje, ktore prevadzka uz ma, a clovek by ich musel prepisovat.
 *
 *   Podla preflightu (P2) nema e-mail ani jeden z doterajsich zakaznikov, takze
 *   toto je JEDINA cesta, ako sa existujuci telefonicky zakaznik dostane na web.
 *
 * Token je v odkaze z mailu a plati 7 dni. Druhe pouzitie server odmietne --
 * ucet uz vtedy heslo ma.
 */
const MIN_HESLO = 8;

function PozvankaPage() {
  const [parametre] = useSearchParams();
  const navigate = useNavigate();
  const { login } = useAuth();
  const { branding } = useTenant();

  const token = parametre.get("t") || "";
  const [heslo, setHeslo] = useState("");
  const [hesloZnova, setHesloZnova] = useState("");
  const [suhlas, setSuhlas] = useState(false);
  const [chyba, setChyba] = useState("");
  const [odosiela, setOdosiela] = useState(false);

  async function odosli(e) {
    e.preventDefault();
    if (heslo.length < MIN_HESLO) { setChyba(`Heslo musí mať aspoň ${MIN_HESLO} znakov.`); return; }
    if (heslo !== hesloZnova) { setChyba("Heslá sa nezhodujú."); return; }
    if (!suhlas) { setChyba("Na dokončenie je potrebný súhlas s podmienkami."); return; }

    setOdosiela(true);
    setChyba("");
    try {
      const { data } = await axios.post(REGISTER_INVITE_CONFIRM_URL, {
        token,
        password: heslo,
        passwordConfirm: hesloZnova,
        agreeTerms: true,
      });
      login(data);
      navigate("/objednavka", { replace: true });
    } catch (err) {
      setChyba(err?.response?.data?.message || "Pozvánku sa nepodarilo dokončiť.");
    } finally {
      setOdosiela(false);
    }
  }

  if (!token) {
    return (
      <main className="pozvanka pozvanka--chyba">
        <h1>Neplatný odkaz</h1>
        <p>Odkaz z pozvánky je neúplný. Skúste ho otvoriť priamo z e-mailu.</p>
        <Link to="/" className="pozvanka__odkaz">Späť na úvod</Link>
      </main>
    );
  }

  return (
    <main className="pozvanka">
      <div className="pozvanka__karta">
        <header className="pozvanka__hlavicka">
          <KeyRound size={34} aria-hidden="true" />
          <h1>Nastavte si heslo</h1>
          <p>
            {/* brandingFor() vracia `displayName` (s fallbackom na nazov firmy),
                nie surovy stlpec `display_name` -- ten tu bol vzdy undefined. */}
            {branding?.displayName
              ? `Odteraz si v ${branding.displayName} objednáte aj sami cez internet.`
              : "Odteraz si objednáte aj sami cez internet."}
            {" "}Vaše doterajšie objednávky zostávajú v konte tak, ako boli.
          </p>
        </header>

        <form className="pozvanka__form" onSubmit={odosli} noValidate>
          <label className="pozvanka__pole">
            <span>Nové heslo</span>
            <input
              type="password"
              value={heslo}
              onChange={(e) => setHeslo(e.target.value)}
              autoComplete="new-password"
              minLength={MIN_HESLO}
              required
            />
            <small>Aspoň {MIN_HESLO} znakov.</small>
          </label>

          <label className="pozvanka__pole">
            <span>Heslo znova</span>
            <input
              type="password"
              value={hesloZnova}
              onChange={(e) => setHesloZnova(e.target.value)}
              autoComplete="new-password"
              required
            />
          </label>

          <Checkbox
            checked={suhlas}
            onChange={setSuhlas}
            /* Rovnaké znenie ako pri registrácii — viď komentár tam. */
            label={
              <>
                Súhlasím s{" "}
                <Link to="/vop" target="_blank" rel="noopener noreferrer">obchodnými podmienkami</Link>
                {" "}a beriem na vedomie{" "}
                <Link to="/ochrana-osobnych-udajov" target="_blank" rel="noopener noreferrer">
                  zásady ochrany osobných údajov
                </Link>.
              </>
            }
          />

          {chyba && <p className="pozvanka__chyba" role="alert">{chyba}</p>}

          <Button type="submit" variant="primary" disabled={odosiela}>
            {odosiela ? "Ukladám..." : "Nastaviť heslo a pokračovať"}
          </Button>
        </form>
      </div>
    </main>
  );
}

export default PozvankaPage;
